import React, { useCallback, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {

    faPaw,
    faDownload,
    faRefresh,
    faFilter,
    faCalendarAlt,
    faClock,
} from '@fortawesome/free-solid-svg-icons';
import api from '../../api/api';
import { CURRENCY_CODE, WALK_STATUS } from '../../config/constants';


import { StatsCard } from '../../components/StatsCard';
import { Menu } from '@headlessui/react';
import WalkDetailModal from './partials/WalkDetails';
import WalkerAssign from './partials/WalkerAssgin';
import LoadingLogo from '../../components/Loading';
import Pagination from '../../components/Pagination';
import { capitalizeWords } from '../../config/utility';
import _ from 'lodash';
import AdminCancelWalk from './partials/AdminCancleWalk';

const AdminWalk = () => {
    const [statsData, setStatsData] = useState({
        active_walkers: 0,
    });
    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isShowModalOpen, setIsShowModalOpen] = useState(false);
    const [isWalkerAssginModalOpen, setIsWalkerAssginModalOpen] = useState(false);

    const [walks, setWalks] = useState([]);
    const [walkers, setWalkers] = useState([]);
    // const [users, setUsers] = useState([]);

    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState('all');
    const [assignedFilter, setAssignedFilter] = useState('all');
    const [paymentStatus, setPaymentStatus] = useState('all');
    const [paymentMethod, setPaymentMethod] = useState('all');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [sortBy, setSortBy] = useState('created_at');
    const [sortOrder, setSortOrder] = useState('desc');
    const [currentPage, setCurrentPage] = useState(1);
    const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
    const [isCancelWalkModalOpen, setIsCancelWalkModalOpen] = useState(false);


    const fetchWalks = useCallback(async () => {
        try {
            setLoading(true);
            const response = await api.get('/walks', {
                params: {
                    search: searchTerm,
                    status: statusFilter !== 'all' ? statusFilter : null,
                    walker_assigned: assignedFilter !== 'all' ? assignedFilter : null,
                    payment_status: paymentStatus !== 'all' ? paymentStatus : null,
                    payment_method: paymentMethod !== 'all' ? paymentMethod : null,
                    from_date: fromDate || null,
                    to_date: toDate || null,
                    sort_by: sortBy,
                    sort_order: sortOrder,
                    page: currentPage,
                },
            });
            setWalks(response.data);
            setMeta(response.meta);
            setWalkers(response.walkers);
            // setUsers(response.users);
            setStatsData((prev) => ({
                ...prev,
                active_walkers: response.active_walkers,
                total_walk: response.meta.total,
            }));
            setLoading(false);
        } catch (error) {
            // Failed to fetch walks
        }
    }, [searchTerm, statusFilter, assignedFilter, paymentStatus, paymentMethod, fromDate, toDate, sortBy, sortOrder, currentPage]);

    // Debounce after wrapping fetchWalks in useCallback
    const debouncedFetchWalks = useCallback(_.debounce(fetchWalks, 500), [fetchWalks]);

    useEffect(() => {
        debouncedFetchWalks();
        return () => debouncedFetchWalks.cancel();
    }, [debouncedFetchWalks]);


    const [meta, setMeta] = useState({
        total: 0,
        per_page: 10,
        current_page: 1,
        last_page: 1,
        from: 1,
        to: 1,
    });
    const [editWalk, setEditWalk] = useState(null); // For editing existing walk

    const statusColorMap = {
        requested: "bg-purple-200 text-purple-800",
        finding_walker: "bg-purple-200 text-purple-800",
        completed: "bg-green-200 text-green-800",
        cancelled: "bg-red-200 text-red-800",
        walker_assigned: "bg-purple-800 text-purple-200",
        heading_to_pickup: "bg-purple-800 text-purple-200",
        picked_up: "bg-purple-800 text-purple-200",
        in_progress: "bg-purple-800 text-purple-200",
    };



    // const handleAdd = () => {
    //     setEditWalk(null); // New walk
    //     setIsModalOpen(true);
    // };

    // const handleEdit = (walk) => {
    //     setEditWalk(walk); // Edit walk
    //     setIsModalOpen(true);
    // };

    const handleShow = (walk) => {
        setEditWalk(walk); // walk
        setIsShowModalOpen(true);
    };

    const handleDownloadCSV = async () => {
        try {
            setLoading(true);

            const response = await api.get('/walks', {
                params: {
                    search: searchTerm,
                    status: statusFilter !== 'all' ? statusFilter : null,
                    walker_assigned: assignedFilter !== 'all' ? assignedFilter : null,
                    payment_status: paymentStatus !== 'all' ? paymentStatus : null,
                    payment_method: paymentMethod !== 'all' ? paymentMethod : null,
                    from_date: fromDate || null,
                    to_date: toDate || null,
                    sort_by: sortBy,
                    sort_order: sortOrder,
                    page: currentPage,
                    want_csv: 1,
                },
                responseType: 'blob',
            });

            // ✅ Create a download link for the CSV
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'walks_export.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setLoading(false);

        } catch (error) {
            // Failed to download CSV
        }
    };


    const handleResetFilters = () => {
        setSearchTerm('')
        setStatusFilter('all')
        setAssignedFilter('all')
        setPaymentStatus('all')
        setPaymentMethod('all')
        setSortBy('created_at')
        setSortOrder('desc')
        setCurrentPage(1)
        setFromDate('')
        setToDate('')
    };


    // const handleCancelWalk = async (id) => {
    //     if (window.confirm('Are you sure you want to cancel this walk?')) {
    //         try {
    //             await api.delete(`/walks/${id}`);
    //             toast.success('Walk canceled successfully.');
    //             fetchWalks();
    //         } catch (error) {
    //             toast.error('Failed to cancel walk.');
    //         }
    //     }
    // };

    const handleCancelWalk = (walk) => {
        setEditWalk(walk)
        setIsCancelWalkModalOpen(true);
    };

    const handleCancel = () => {
        setIsCancelWalkModalOpen(false);
        fetchWalks();
    };


    // const handleSave = () => {
    //     setIsModalOpen(false);
    //     fetchWalks();
    // };

    const handleNextPage = () => {
        if (meta.current_page < meta.last_page) {
            setCurrentPage(meta.current_page + 1);
        }
    };

    const handlePrevPage = () => {
        if (meta.current_page > 1) {
            setCurrentPage(meta.current_page - 1);
        }
    };

    const renderPageNumbers = () => {
        const pages = [];
        for (let i = 1; i <= meta.last_page; i++) {
            pages.push(
                <button
                    key={i}
                    onClick={() => setCurrentPage(i)}
                    className={`px-3 py-1 rounded-full ${i === meta.current_page ? 'bg-primary text-white' : 'bg-white text-gray-700'
                        } hover:bg-primary hover:text-white mx-1`}
                >
                    {i}
                </button>
            );
        }
        return pages;
    };
    // return <LoadingLogo/>;

    if (loading) {
        return <LoadingLogo />;
    }

    const handleDirectCancelWalk = async (walk) => {
        if (window.confirm('Are you sure you want to cancel this walk?')) {
            try {
                await api.post(`/walks/${walk.id}/cancel`);
                fetchWalks();
            } catch (error) {
                // Failed to cancel walk
            }
        }
    };

    return (
        <div className="mx-auto px-4  max-w-full overflow-x-hidden">
            {/* Advanced Filters Section */}
            <div className={`transition-all duration-300 ${showAdvancedFilters ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
                }`}>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mb-4">

                    {/* Walk Status */}
                    <div className="flex flex-col">
                        <label htmlFor="breed-filter" className="text-tblue font-medium mb-1">
                            Status
                        </label>

                        <select className="border border-gray-300 rounded-lg p-2 bg-white shadow-sm focus:outline-none focus:ring-1 focus:ring-primary transition duration-200"
                            value={statusFilter} onChange={(e) => { setStatusFilter(e.target.value); setCurrentPage(1); }} >
                            <option value="all">All Walks</option>
                            <option value="ongoing">Ongoing Walks</option>
                            <option value="scheduled">Scheduled Walks</option>
                            {Object.entries(WALK_STATUS).map(([key, value]) => (
                                <option key={key} value={value}>{capitalizeWords(value) + ' Walks'}</option>
                            ))}
                        </select>
                    </div>


                    {/* Walker Assigned */}
                    <div className="flex flex-col">
                        <label htmlFor="breed-filter" className="text-tblue font-medium mb-1">
                            Walker Status
                        </label>

                        <select className="border border-gray-300 rounded-lg p-2 bg-white shadow-sm focus:outline-none focus:ring-1 focus:ring-primary transition duration-200"
                            value={assignedFilter} onChange={(e) => { setAssignedFilter(e.target.value); setCurrentPage(1); }}>
                            <option value="all">All</option>
                            <option value="assigned">Assigned</option>
                            <option value="unassigned">Unassigned</option>
                        </select>
                    </div>

                    {/* Payment Status */}
                    <div className="flex flex-col">
                        <label htmlFor="breed-filter" className="text-tblue font-medium mb-1">
                            Payment Status
                        </label>

                        <select className="border border-gray-300 rounded-lg p-2 bg-white shadow-sm focus:outline-none focus:ring-1 focus:ring-primary transition duration-200"
                            value={paymentStatus} onChange={(e) => { setPaymentStatus(e.target.value); setCurrentPage(1); }}>
                            <option value="all">All</option>
                            <option value="paid">Paid</option>
                            <option value="unpaid">Unpaid</option>
                        </select>
                    </div>

                    {/* Payment Method */}
                    <div className="flex flex-col">
                        <label htmlFor="breed-filter" className="text-tblue font-medium mb-1">
                            Payment Method
                        </label>

                        <select className="border border-gray-300 rounded-lg p-2 bg-white shadow-sm focus:outline-none focus:ring-1 focus:ring-primary transition duration-200"
                            value={paymentMethod} onChange={(e) => { setPaymentMethod(e.target.value); setCurrentPage(1); }}>
                            <option value="all">All</option>
                            <option value="MamoPay">Online Payment</option>
                            <option value="Cash On Delivery">Cash on Delivery</option>
                        </select>
                    </div>

                    {/* Date Filters */}
                    {/* <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                        <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} /> */}

                    {/* Sorting */}
                    <div className="flex flex-col">
                        <label htmlFor="breed-filter" className="text-tblue font-medium mb-1">
                            Sort From
                        </label>

                        <select className="border border-gray-300 rounded-lg p-2 bg-white shadow-sm focus:outline-none focus:ring-1 focus:ring-primary transition duration-200"
                            value={sortBy} onChange={(e) => { setSortBy(e.target.value); setCurrentPage(1); }}>
                            <option value="created_at">Date Created</option>
                            <option value="scheduled_at"> Scheduled Date</option>
                            <option value="charge">Charge</option>
                            <option value="status">Status</option>
                        </select>
                    </div>

                    {/* Sort Order */}
                    <div className="flex flex-col">
                        <label htmlFor="breed-filter" className="text-tblue font-medium mb-1">
                            Sort by
                        </label>

                        <select className="border border-gray-300 rounded-lg p-2 bg-white shadow-sm focus:outline-none focus:ring-1 focus:ring-primary transition duration-200"
                            value={sortOrder} onChange={(e) => { setSortOrder(e.target.value); setCurrentPage(1); }}>
                            <option value="desc">Descending</option>
                            <option value="asc">Ascending</option>
                        </select>
                    </div>

                    <div className="flex flex-col">
                        <label htmlFor="breed-filter" className="text-tblue font-medium mb-1 ">
                            CSV
                        </label>


                        <button onClick={handleDownloadCSV} className="border p-2 rounded-lg bg-green-600 text-white">
                            <FontAwesomeIcon icon={faDownload} className="mr-2" />
                            Download
                        </button>
                    </div>

                </div>
            </div>

            {/* Header Section - Stack on mobile */}
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 space-y-4 sm:space-y-0">
                <h1 className="text-[#3E358F] text-3xl font-bold">Walks Overview</h1>

                <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4 w-full sm:w-auto">
                    {showAdvancedFilters && (
                        <button
                            onClick={handleResetFilters}
                            className="px-3 py-2 text-sm font-medium bg-red-500 text-white rounded-lg shadow-md hover:bg-red-600 transition-all duration-300 w-full sm:w-auto"
                        >
                            <FontAwesomeIcon icon={faRefresh} className="mr-2" />
                            Reset Filters
                        </button>
                    )}

                    <button
                        onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
                        className="bg-tblue text-white px-4 py-2 rounded-lg flex items-center justify-center gap-2 shadow-md hover:bg-[#2c257e] transition-all duration-300 w-full sm:w-auto"
                    >
                        <FontAwesomeIcon icon={faFilter} />
                        Filters
                    </button>
                </div>
            </div>

            {/* Stats Section - Responsive grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
                <StatsCard title="Total Walk" value={statsData?.total_walk} />
                <StatsCard title="Active Walkers" value={statsData?.active_walkers} />
            </div>

            {/* Table Section */}
            <div className="overflow-x-auto relative rounded-lg">
                <table className="min-w-full bg-white rounded-lg shadow-md">
                    <thead className="bg-primary text-white">
                        <tr>
                            <th className="py-4 px-4 text-left sticky left-0 bg-primary z-10 border-r border-white">ID</th>
                            <th className="py-4 px-4 text-left">Walker</th>
                            <th className="py-4 px-4 text-left">Pets</th>
                            <th className="py-4 px-4 text-left">Scheduled At</th>
                            <th className="py-4 px-4 text-left">Payment Status</th>
                            <th className="py-4 px-4 text-left">Payment Method</th>
                            <th className="py-4 px-4 text-left">Charge</th>
                            <th className="py-4 px-4 text-left">Status</th>
                            <th className="py-4 px-4 text-center">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                        {walks.length > 0 ? (
                            walks.map((walk, index) => (
                                <tr key={index} className="border-b hover:bg-gray-50">
                                    <td className="py-3 px-4 font-semibold text-gray-700 whitespace-nowrap sticky left-0 bg-white z-10 border-r border-gray-200">
                                        #{walk.id}
                                    </td>
                                    <td className="py-3 px-4">
                                        <div className="flex items-center space-x-2">
                                            <FontAwesomeIcon icon={faPaw} className="text-primary" />
                                            <span className="truncate">{walk.walker ? walk.walker.name : 'Unassigned'}</span>
                                        </div>
                                    </td>
                                    <td className="py-3 px-4 min-w-[120px]">
                                        <div className="flex items-center">
                                            {walk.pets && walk.pets.length > 0 ? (
                                                <div className="flex flex-wrap -space-x-2">
                                                    {walk.pets.slice(0, 3).map((pet, index) => (
                                                        <div
                                                            key={index}
                                                            className="relative inline-block"
                                                            style={{ zIndex: 3 - index }}
                                                        >
                                                            <img
                                                                src={pet.primary_image_url}
                                                                alt={pet.name}
                                                                className="w-8 h-8 sm:w-10 sm:h-10 rounded-full object-cover shadow-md border-2 border-white"
                                                                title={pet.name}
                                                            />
                                                        </div>
                                                    ))}
                                                    {walk.pets.length > 3 && (
                                                        <div
                                                            className="relative inline-flex items-center justify-center"
                                                            style={{ zIndex: 5 }}
                                                        >
                                                            <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gray-300 flex items-center justify-center text-xs sm:text-sm font-bold text-white border-2 border-white shadow-md">
                                                                +{walk.pets.length - 3}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <span className="text-sm text-gray-500">No pets</span>
                                            )}
                                        </div>
                                    </td>
                                    <td className="py-3 px-4 whitespace-nowrap">
                                        {walk.scheduled_at ?
                                            <div className="flex items-center space-x-2">
                                                <div className="flex items-center bg-blue-50 text-blue-700 px-3 py-1 rounded-lg border border-blue-200">
                                                    <FontAwesomeIcon icon={faCalendarAlt} className="mr-2 text-sm" />
                                                    <span className="text-sm font-medium">
                                                        {new Date(walk.scheduled_at).toLocaleString('en-US', {
                                                            year: 'numeric',
                                                            month: 'short',
                                                            day: 'numeric',
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true
                                                        })}
                                                    </span>
                                                </div>
                                            </div> :
                                            <span className="px-2 py-1 rounded-full text-xs font-bold bg-yellow-100 text-yellow-800">Instant</span>
                                        }
                                    </td>
                                    <td className="py-3 px-4">
                                        <span className={`px-2 py-1 rounded-full text-xs font-bold ${walk.payment_status === 1
                                            ? "bg-green-100 text-green-800"
                                            : "bg-red-100 text-red-800"
                                            }`}>
                                            {walk.payment_status === 1 ? "Paid" : "Not Paid"}
                                        </span>
                                    </td>
                                    <td className="py-3 px-4">
                                        {walk.payment_method ? (
                                            walk.payment_method === "MamoPay" ? (
                                                <span className="px-3 py-1 rounded-full text-xs font-bold bg-blue-200 text-blue-800">
                                                    MamoPay
                                                </span>
                                            ) : (
                                                <span className="px-3 py-1 rounded-full text-xs font-bold bg-gray-200 text-gray-800">
                                                    Cash on Delivery
                                                </span>
                                            )
                                        ) : (
                                            <span className="px-3 py-1 rounded-full text-xs font-bold bg-yellow-200 text-yellow-800">
                                                Not Selected
                                            </span>
                                        )}
                                    </td>
                                    <td className="py-3 px-4 whitespace-nowrap">
                                        {walk.charges?.total ? `${walk.charges.total} ${CURRENCY_CODE}` : 'N/A'}
                                    </td>
                                    <td className="py-3 px-4">
                                        <span className={`px-2 py-1 rounded-full text-xs font-bold ${statusColorMap[walk.status]}`}>
                                            {capitalizeWords(walk.status)}
                                        </span>
                                    </td>
                                    <td className="py-3 px-4 text-center">
                                        <Menu as="div" className="relative inline-block text-left">
                                            <Menu.Button className="text-gray-500 hover:text-gray-700 cursor-pointer ">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    strokeWidth="2"
                                                    stroke="currentColor"
                                                    className="w-6 h-6"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M12 6.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12 12.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12 18.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
                                                    />
                                                </svg>
                                            </Menu.Button>

                                            <Menu.Items className="absolute right-5 -top-10 w-40 bg-bodyMain shadow-lg rounded-lg border border-accent focus:outline-none">
                                                <div className="py-1">
                                                    <Menu.Item>
                                                        {({ active }) => (
                                                            <button
                                                                className={`${active ? 'bg-primary text-white' : 'text-gray-700'
                                                                    } group flex rounded-md items-center justify-center w-full px-4 py-2 text-sm`}
                                                                onClick={() => handleShow(walk)}
                                                            >
                                                                View Details
                                                            </button>
                                                        )}
                                                    </Menu.Item>
                                                    {walk.status === WALK_STATUS.REQUESTED && (
                                                        <Menu.Item>
                                                            {({ active }) => (
                                                                <button
                                                                    className={`${active ? 'bg-primary text-white' : 'text-gray-700'
                                                                        } group flex rounded-md items-center justify-center w-full px-4 py-2 text-sm`}
                                                                    onClick={() => handleCancelWalk(walk)}
                                                                >
                                                                    Cancel Walk
                                                                </button>
                                                            )}
                                                        </Menu.Item>
                                                    )}
                                                    {walk.walker == null && (
                                                        <Menu.Item>
                                                            {({ active }) => (
                                                                <button
                                                                    className={`${active ? 'bg-primary text-white' : 'text-gray-700'
                                                                        } group flex rounded-md items-center justify-center w-full px-4 py-2 text-sm`}
                                                                    onClick={() => {
                                                                        setEditWalk(walk);
                                                                        setIsWalkerAssginModalOpen(true);
                                                                    }}
                                                                >
                                                                    Assign Walker
                                                                </button>
                                                            )}
                                                        </Menu.Item>
                                                    )}
                                                    {(walk.status === WALK_STATUS.REQUESTED || walk.status === WALK_STATUS.FINDING_WALKER) && (
                                                        <Menu.Item>
                                                            {({ active }) => (
                                                                <button
                                                                    className={`${active ? 'bg-red-600 text-white' : 'text-red-600'} group flex rounded-md items-center justify-center w-full px-4 py-2 text-sm`}
                                                                    onClick={() => handleCancelWalk(walk)}
                                                                >
                                                                    Cancel Walk
                                                                </button>
                                                            )}
                                                        </Menu.Item>
                                                    )}
                                                </div>
                                            </Menu.Items>
                                        </Menu>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="9" className="py-8 text-center text-gray-500">
                                    No walks found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Smart Pagination */}
            <Pagination
                meta={meta}
                onPageChange={(page) => setCurrentPage(page)}
            />

            {/* {isModalOpen && (
                <CRUModal
                    item={editWalk}
                    pets={ownerPets}
                    tools={tools}
                    onSave={handleSave}
                    onCancel={() => setIsModalOpen(false)}
                />
            )} */}



            {isShowModalOpen && (
                <WalkDetailModal
                    walk={editWalk}
                    isOpen={isShowModalOpen}
                    onClose={() => setIsShowModalOpen(false)}
                />
            )}

            {isWalkerAssginModalOpen && (
                <WalkerAssign
                    walk={editWalk}
                    isOpen={isWalkerAssginModalOpen}
                    onClose={() => {
                        setIsWalkerAssginModalOpen(false)
                        fetchWalks()
                    }}
                    walkers={walkers}
                />
            )}


            {isCancelWalkModalOpen && (
                <AdminCancelWalk
                    onCancel={handleCancel}
                    isOpen={isCancelWalkModalOpen}
                    walk={editWalk}
                />
            )}

        </div>
    );
};

export default AdminWalk;
